<template>
  <v-card
    flat
    class="tab-tray"
  >
    <v-tabs
      v-if="tabs?.length"
    >
      <v-tab
        v-for="tab in tabs"
        :key="tab.id"
        :value="tab.id"
        @click="$emit('tab-selected', tab.id)"
      >
        <IconTab :tab="tab" />
      </v-tab>
    </v-tabs>
  </v-card>
</template>

<script>
import IconTab from './IconTab.vue';

export default {
  name: 'TabTray',
  components: {
    IconTab,
  },
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['tab-selected'],
};
</script>

<style scoped lang="scss">
.tab-tray {
  background-color: main.$lightGray;
}
// eslint-disable-next-line vue-scoped-css/no-unused-selector
.v-tab.v-tab {
  display: flex;
  min-width: 90px;

  @include main.respond(desktop) {
    min-width: 80px;
  }

  &.v-btn {
    min-width: 70px;
  }
 }
</style>
